import {
  afterNextRender,
  Component,
  inject,
  input,
  viewChild,
} from '@angular/core';
import { IonicModule, IonNav } from '@ionic/angular';
import { MODULE_ACTIONS } from '@marineform/manage-data-access';
import { RecordMenuRootComponent } from './record-menu-root.component';

@Component({
  selector: '',
  template: ` <ion-nav></ion-nav> `,
  imports: [IonicModule],
})
export class RecordMenuComponent {
  nav = viewChild.required(IonNav);
  readonly #moduleActions = inject(MODULE_ACTIONS);
  constructor() {
    afterNextRender(() => {
      void (async () => {
        await this.nav().setRoot(RecordMenuRootComponent, {
          nav: this.nav(),
          actions: this.#moduleActions,
        });
      })();
    });
  }
}
